import React from 'react'
import treePilotIconBN from 'imgs/TreePilotIconBN.png'
import 'stylesheets/Skeletons/TreePilotLoading.css'
const TreePilotLoading = () => {
    return (
        <div className='treePilot-loading'>
            <img src={treePilotIconBN} alt="" />
        </div>
    )
}

export default TreePilotLoading